import { createClient, type SupabaseClient } from '@supabase/supabase-js'

const CLAVE_RECORDAR = 'uniper.recordar-sesion'

/** «Mantener sesión»: apagado por defecto. Apagado = la sesión vive solo en esta pestaña. */
export function recordarSesion(): boolean {
  try {
    return localStorage.getItem(CLAVE_RECORDAR) === '1'
  } catch {
    return false
  }
}

export function fijarRecordarSesion(si: boolean) {
  try {
    if (si) localStorage.setItem(CLAVE_RECORDAR, '1')
    else localStorage.removeItem(CLAVE_RECORDAR)
  } catch {
    /* almacenamiento bloqueado: se queda en la pestaña */
  }
}

/** Guarda la sesión en localStorage si se pidió recordar, si no en sessionStorage. */
const almacenamiento = {
  getItem: (k: string) => {
    try {
      return sessionStorage.getItem(k) ?? localStorage.getItem(k)
    } catch {
      return null
    }
  },
  setItem: (k: string, v: string) => {
    try {
      if (recordarSesion()) {
        localStorage.setItem(k, v)
        sessionStorage.removeItem(k)
      } else {
        sessionStorage.setItem(k, v)
        localStorage.removeItem(k)
      }
    } catch {
      /* sin almacenamiento disponible */
    }
  },
  removeItem: (k: string) => {
    try {
      localStorage.removeItem(k)
      sessionStorage.removeItem(k)
    } catch {
      /* nada que borrar */
    }
  },
}

let cliente: SupabaseClient | undefined

/**
 * Cliente único de Supabase. Solo conoce la URL y la publishable key;
 * todo lo sensible lo decide la base con RLS (reglas críticas 3 y 4).
 */
export function supabase(): SupabaseClient {
  if (cliente) return cliente
  const url = import.meta.env.VITE_SUPABASE_URL
  const llave = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY
  if (!url || !llave) {
    throw new Error(
      'Faltan VITE_SUPABASE_URL o VITE_SUPABASE_PUBLISHABLE_KEY (ver app/.env.example)',
    )
  }
  cliente = createClient(url, llave, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storage: almacenamiento,
    },
  })
  return cliente
}
